export const kratos_recovery_flow = {
  recovery_failed:
    "Recovery could not be completed. Check your input and try again.",
  resend_help: "Need a new recovery link?",
  cta_new_flow: "Start again",
};
